export const categories = [
  {
    category: "Fat Burning & Endurance",
    home: [
      "Skipping rope",
      "Zumba/Dance workouts",
      "Burpees",
      "Jump squats",
      "Mountain climbers",
      "Climbing stairs",
      "Wall Sits",
      "Leg Raises",
      "Jumping Jacks",
      "High Knees",
      "Skater Jumps",
      "Shadow Boxing Cardio",
      "Tabata",
    ],
    outdoors: [
      "Running",
      "Walking",
      "Power walking",
      "Misuse",
      "Climbing stairs",
      "Sprint training",
      "Swimming",
      "Trail running",
      "Roller skates",
    ],
    gym: [
      "Elliptical trainer",
      "Rowing machine",
      "Spinning",
      "Treadmill Interval Training",
      "Circuit training",
      "Zumba/Dance workouts",
      "StepMill",
      "Swimming",
      "HIIT",
      "Stair Climber Sprints",
      "Airbike",
      "Kettlebell cardio circuit",
    ],
  },
  {
    category: "Muscle Building & Strength Training",
    home: [
      "Push-ups",
      "Squats",
      "Lunges",
      "Plank",
      "Resistance band Workouts",
      "Sit-ups",
      "Russian Twists",
      "Leg Raises",
      "Stretching",
      "Bulgarian Split Squats",
      "Glute Bridges",
      "Superman",
      "Side Plank",
    ],
    outdoors: [
      "Calisthenics",
      "TRX training outdoor",
      "Sprint and stair training",
      "Swimming",
      "Farmer's Carry",
      "Pull-ups (stretching)",
    ],
    gym: [
      "Weightlifting",
      "Squats",
      "Deadlifts",
      "Bench press",
      "Kettlebell workouts",
      "Leg Press",
      "Chest Press",
      "Spinning",
      "Cross trainer",
      "Treadmill",
      "Battle Ropes",
      "Leg Raises",
      "Swimming",
      "TRX training",
      "Overhead Press",
      "Lat Pulldown",
      "Cable Machine",
      "Landmine Exercises",
    ],
  },
  {
    category: "Flexibility & Relaxation",
    home: [
      "Yoga",
      "Stretching and mobility exercises",
      "Pilates",
      "Foam rollers",
      "Dynamic Stretching Flow",
    ],
    outdoors: [
      "Outdoor yoga",
      "Tai Chi",
      "Dynamic stretching while walking",
      "Qi Gong",
      "Walking Lunges with stretch",
    ],
    gym: [
      "Foam rollers",
      "Mobility training",
      "Yoga",
      "Stretching classes",
      "Pilates",
      "Assisted Stretching",
    ],
  },
  {
    category: "Full-Body & Endurance Sports",
    home: [
      "Rowing with resistance bands",
      "Shadow boxing",
      "Bodyweight circuits",
      "AMRAP workouts",
    ],
    outdoors: [
      "Swimming",
      "Kayaking",
      "SUP",
      "Obstacle course training",
      "To run",
      "Cross-country skiing",
      "Trail Obstacle Running",
    ],
    gym: [
      "Rowing machine",
      "Indoor Cycling",
      "Swimming",
      "Leg Press",
      "Chest Press",
      "Spinning",
      "Cross trainer",
      "Treadmill",
      "Sled Push/Pull",
      "Functional Training Circuits",
    ],
  },
];

export const categoriesInDutch = [
  {
    category: "Vetverbranding & Uithoudingsvermogen",
    home: [
      "Touwtjespringen",
      "Zumba/Dansworkouts",
      "Burpees",
      "Jump squats",
      "Mountain climbers",
      "Traplopen",
      "Wall Sits",
      "Leg Raises",
      "Jumping Jacks",
      "High Knees",
      "Skater Jumps",
      "Shadow Boxing Cardio",
      "Tabata",
    ],
    outdoors: [
      "Rennen",
      "Wandelen",
      "Powerwalking",
      "Fietsen",
      "Traplopen",
      "Sprinttraining",
      "Zwemmen",
      "Trailrunning",
      "Rolschaatsen",
    ],
    gym: [
      "Elliptische trainer",
      "Roeimachine",
      "Spinning",
      "Loopband Intervaltraining",
      "Circuittraining",
      "Zumba/Dansworkouts- StepMill",
      "Zwemmen",
      "HIIT",
      "Stair Climber Sprints",
      "Airbike",
      "Kettlebell cardio circuit",
    ],
  },
  {
    category: "Spieropbouw & Krachttraining",
    home: [
      "Push-ups",
      "Squats",
      "Lunges",
      "Plank",
      "Weerstandsbandtrainingen",
      "Sit-ups",
      "Russian Twists",
      "Leg Raises",
      "Stretching",
      "Bulgarian Split Squats",
      "Glute Bridges",
      "Superman",
      "Side Plank",
    ],
    outdoors: [
      "Calisthenics",
      "TRX-training outdoor",
      "Sprint- en traptraining",
      "Zwemmen",
      "Farmer's Carry",
      "Pull-ups (rekken)",
    ],
    gym: [
      "Gewichtheffen",
      "Squats",
      "Deadlifts",
      "Bankdrukken",
      "Kettlebell-trainingen- Leg Press",
      "Chest Press",
      "Spinning",
      "Cross trainer",
      "Loopband",
      "Battle Ropes",
      "Leg Raises",
      "Zwemmen",
      "TRX-training",
      "Overhead Press",
      "Lat Pulldown",
      "Cable Machine",
      "Landmine Oefeningen",
    ],
  },
  {
    category: "Flexibiliteit & Ontspanning",
    home: [
      "Yoga",
      "Rek- en mobiliteitsoefeningen",
      "Pilates",
      "Foamrollen",
      "Dynamic Stretching Flow",
    ],
    outdoors: [
      "Buitenyoga",
      "Tai Chi",
      "Dynamisch rekken tijdens een wandeling",
      "Qi Gong",
      "Walking Lunges met stretch",
    ],
    gym: [
      "Foamrollen",
      "Mobiliteitstraining",
      "Yoga",
      "Stretchlessen",
      "Pilates",
      "Assisted Stretching",
    ],
  },
  {
    category: "Full-Body & Duursporten",
    home: [
      "Roeien met weerstandsbanden",
      "Schaduwboksen",
      "Bodyweight circuits",
      "AMRAP-workouts",
    ],
    outdoors: [
      "Zwemmen",
      "Kajakken",
      "Suppen",
      "Hindernisbaantraining",
      "Hardlopen",
      "Langlaufen",
      "Trail Obstacle Running",
    ],
    gym: [
      "Roeimachine",
      "Indoor Cycling",
      "Zwemmen",
      "Leg Press",
      "Chest Press",
      "Spinning",
      "Cross trainer",
      "Loopband",
      "Sled Push/Pull",
      "Functional Training Circuits",
    ],
  },
];

export const exercisePreferences = [
  // {
  //   label: "Exercise Goal",
  //   key: "exerciseGoal",
  //   type: "select",
  //   options: [
  //     "Lose weight",
  //     "Improve endurance",
  //     "Get toned",
  //     "Physiotherapy",
  //     "Increase mobility",
  //     "Build strength",
  //   ],
  // },
  {
    label: "Equipment Categories",
    key: "equipmentCategories",
    type: "select",
    options: ["Free Weights", "Bodyweight", "Gym Equipment"],
    // type: "multi-select",
    // options: [
    //   "Kettlebell",
    //   "Dumbbell",
    //   "Med Ball",
    //   "Barbell",
    //   "Mat",
    //   "Elastic Band",
    //   "Sandbag",
    //   "TRX",
    //   "Bench",
    //   "Jump Rope",
    //   "Free Weight",
    //   "Stepper",
    //   "Ab Wheel",
    //   "Adjustable Bench",
    //   "Agility Ladder",
    //   "Bench Press",
    //   "BOSU Ball",
    //   "Cable Biceps Bar",
    //   "Cable Triceps Bar",
    //   "Chest Press",
    //   "Crunch Machine",
    //   "Cycling Bike",
    //   "Decline Bench",
    //   "Elliptical Machine",
    //   "EZ Curl Bar",
    //   "Foam Roller",
    //   "Hack Squat Machine",
    //   "Hammer Strength Machine",
    //   "Incline Bench",
    //   "Incline Bench Press",
    //   "Lat Pulldown",
    //   "Leg Adduction / Abduction Machine",
    //   "Leg Curl Machine",
    //   "Leg Extension Machine",
    //   "Leg Press",
    //   "Pec Deck Machine",
    //   "Plyo Box",
    //   "Power Tower",
    //   "Preacher Bench",
    //   "Pull-up Bar",
    //   "Punching Bag",
    //   "Push-up Stands",
    //   "Rowing Machine",
    //   "Sit-up Bench",
    //   "Smith Machine",
    //   "Squat Rack",
    //   "Stair Stepper",
    //   "Treadmill",
    //   "Triceps Bar",
    //   "Booty Band",
    //   "Flat Band",
    //   "Loop Band",
    //   "Stability Ball",
    //   "Tube Band",
    //   "Balance Pad",
    //   "Rope Cables",
    //   "Reverse Hyper Machine",
    //   "Olympic Plate",
    //   "Battling Ropes",
    //   "Hurdle",
    //   "Cones",
    //   "Handle Medicine Ball",
    //   "Cable machine",
    //   "Chest press machine",
    //   "Row machine",
    //   "Tricep press machine",
    //   "Bicep curl machine",
    //   "Lateral pulldown machine",
    //   "Abdominal machine",
    //   "Seated leg press machine",
    //   "Shoulder press machine",
    //   "Assisted chin dip machine",
    //   "Glute machine",
    //   "Pectoral fly/rear deltoid machine",
    //   "Hip adduction machine",
    //   "Upright bike",
    //   "Air bike",
    //   "Indoor rowing machine",
    //   "Slant Board",
    //   "Gliding discs",
    //   "Resistance band set",
    //   "Pilates bar",
    //   "Pilates ring",
    //   "Push-up board",
    //   "ViPR",
    //   "Bodyweight",
    //   "Yoga Brick",
    //   "Swiss Ball",
    //   "Chair",
    //   "T-Bar",
    //   "Power Bag",
    //   "Landmine",
    //   "Hex Bar",
    //   "Pilates Ring",
    //   "Pilates Ball",
    // ],
  },
  {
    label: "Difficulties",
    key: "difficultiesLevel",
    type: "select",
    options: ["beginner", "intermediate", "advanced"],
  },

  {
    label: "Workouts Categories",
    key: "workoutsCategories",
    type: "multi-select",
    options: [
      "Endurance",
      "Strength",
      "Balance",
      "Mobility",
      "Cardio",
      "HIIT",
      "Pilates",
      "Physiotherapy",
      "Other",
      "Yoga",
      "Tabata",
      "Sport Mastery",
    ],
  },
];

export const initialExercisePreferences = {
  age: 25,
  gender: "Male",
  // exerciseGoal: "",
  // equipmentCategories: [],
  equipmentCategories: "",
  difficultiesLevel: "",
  workoutsCategories: [],
};
